import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';

import { EmotionBreakpoint } from 'dw-us-ui';

// Styled Components
// ${EmotionBreakpoint('tablet')} {
// ${EmotionBreakpoint('mobile')} {
const TestimonialsSectionContainer = styled.div`
	background: #fff;
	display: flex;
	padding: 40px 6%;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	overflow-x: hidden;
	${EmotionBreakpoint('mobile')} {
		padding: 36px 16px;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 36px 16px;
	}

	.TestimonialsItemScroll {
		${EmotionBreakpoint('mobile')} {
			width: 100vw;
			box-sizing: border-box;
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			scroll-snap-type: x mandatory;
		}
		${EmotionBreakpoint('tablet')} {
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			scroll-snap-type: x mandatory;
		}
	}
	.TestimonialsItemScroll::-webkit-scrollbar {
		display: none; /* Chrome, Safari, Opera */
	}
`;

const TestimonialsHeading = styled.h2`
	color: #2b2a2f;
	text-align: center;
	font-family: 'Escrow Banner Compressed', sans-serif;
	font-size: 40px;
	font-style: normal;
	font-weight: 500;
	line-height: 112%;
	white-space: nowrap;
	.fox & {
		color: var(--Base-Colors-Black, #222);
		text-align: center;
		/* Fox/Desktop/H2 */
		font-family: Roboto;
		font-size: 34px;
		font-style: normal;
		font-weight: 900;
		line-height: 105%;
		letter-spacing: -1.02px;
		text-transform: none;
		text-transform: uppercase;
	}
	.bon & {
		color: var(--Base-Colors-Black, #222);
		text-align: center;
		font-family: 'FuturaPT';
		font-size: 32px;
		font-style: normal;
		font-weight: 600;
		line-height: 40px;
		letter-spacing: 1.28px;
		text-transform: uppercase;
	}
	.law & {
		font-family: 'Oswald';
		text-transform: uppercase;
	}
	.osw & {
		font-family: 'Neue Aachen Pro';
	}
	.npr & {
		font-family: 'Gotham';
	}
	.wsj & {
		text-transform: uppercase;
	}
	${EmotionBreakpoint('mobile')} {
		width: 343px;
		font-size: 32px;
		white-space: wrap;
	}
	${EmotionBreakpoint('tablet')} {
		width: 343px;
		font-size: 32px;
		white-space: wrap;
	}
`;

const TestimonialsSectionList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	justify-content: space-between;
`;

const TestimonialsItem = styled.div`
	display: flex;
	align-items: center;
	flex: 1 1 calc(33.33% - 20px); /* Default to 3 items per row on desktop */
	text-align: center;
	background: #fff;
	padding: 20px;
	flex-direction: column;
	text-align: left;
	align-items: flex-start;

	${EmotionBreakpoint('mobile')} {
		width: 100vw;
		box-sizing: border-box;
		scroll-snap-align: center;
		padding: 16px;
		flex: 0 0 100%; /* Take full width on mobile */
	}
	${EmotionBreakpoint('tablet')} {
		min-width: 100%;
		box-sizing: border-box;
		scroll-snap-align: center;
		padding: 16px;
	}
	.image-wrap {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
		${EmotionBreakpoint('mobile')} {
			gap: 16px;
		}
		${EmotionBreakpoint('tablet')} {
			gap: 16px;
		}
	}
	hr {
		width: 100%;
		height: 1px;
		background: #bcbcbc;
		margin: 12px 0;
		border: none;
	}
	img {
		width: 64px;
		height: 64px;
		${EmotionBreakpoint('mobile')} {
			width: 48px;
			height: 48px;
		}
		${EmotionBreakpoint('tablet')} {
			width: 48px;
			height: 48px;
		}
	}

	.lp-testimonial-item-info {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.reviews-Titles {
		align-self: stretch;
		color: #2b2a2f;
		font-family: Arial;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 24px;
		padding-top: 12px;
		padding-bottom: 12px;
		.fox & {
			color: var(--Base-Colors-Black, #222);
			font-family: Roboto;
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 140%;
		}
		.bon & {
			color: var(--Base-Colors-Black, #222);
			font-family: 'FuturaPT';
			font-size: 16px;
			font-style: normal;
			font-weight: 700;
			line-height: 22px;
		}
		.wsj & {
			font-weight: 700;
		}
		.law & {
			color: #222222;
			font-family: Roboto;
			font-size: 16px;
			font-weight: 600;
		}
		.osw & {
			color: #222222;
			font-family: Roboto;
			font-size: 16px;
			font-weight: 600;
		}
		.npr & {
			color: #222222;
			font-family: Roboto;
			font-size: 16px;
			font-weight: 600;
		}
	}

	.reviews-Bodys {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		align-self: stretch;
		overflow: hidden;
		color: var(--WSJ-Primary-Ink-Black, #2b2a2f);
		text-overflow: ellipsis;
		font-family: Arial;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px; /* 142.857% */
		.fox & {
			overflow: hidden;
			color: var(--Base-Colors-Black, #222);
			text-overflow: ellipsis;
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 130%;
		}
		.bon & {
			font-family: 'FuturaPT';
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
		}
		.law & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-weight: 400;
		}
		.osw & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-weight: 400;
		}
		.npr & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-weight: 400;
		}
	}

	h3 {
		color: #2b2a2f;
		font-family: Arial;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 20px;
		.fox & {
			color: var(--Base-Colors-Black, #222);
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 700;
			line-height: 130%;
		}
		.bon & {
			color: var(--Base-Colors-Black, #222);
			font-family: 'FuturaPT';
			font-size: 16px;
			font-style: normal;
			font-weight: 700;
			line-height: 22px;
		}
		.law & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 600;
		}
		.osw & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 600;
		}
		.npr & {
			color: #222222;
			font-family: Roboto;
			font-size: 14px;
			font-style: normal;
			font-weight: 600;
		}
		.wsj & {
			font-weight: 700;
		}
	}
	.star-ratings {
		display: flex;
		gap: 4px; /* Adjust space between stars */
		margin-bottom: 8px; /* Add spacing between stars and text */
		align-items: center; /* Align stars vertically */
	}

	.lp-testimonial-item-content {
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`;

const CarouselControls = styled.div`
	margin-top: 20px;
	display: flex;
	justify-content: space-between; /* Ensures arrows are positioned correctly */
	align-items: center;
	width: 100%;
	padding: 0 16px; /* Adds space on both sides */
	box-sizing: border-box;

	img {
		width: 15px;
		height: 15px;
	}

	button {
		padding: 7px;

		cursor: pointer;
		margin: 0 5px;
		font-size: 16px;

		&:disabled {
			cursor: not-allowed;
		}
	}
`;

const DotContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 5px;
`;

const Dot = styled.button`
	background-color: ${(props) => (props.active ? '#E92440' : 'transparent')};
	border-radius: 50%;
	width: 12px;
	height: 12px;
	cursor: pointer;
	border: ${(props) => (props.active ? '1px solid' : '1px solid')};
	border-color: ${(props) => (props.active ? '#E92440' : '#2B2A2F')};
	.bon & {
		background-color: ${(props) => (props.active ? '#222' : 'transparent')};
		border-color: ${(props) => (props.active ? '#222' : '#222')};
	}
`;

const TestimonialsSection = ({ contentfulData, brandTag }) => {
	const {
		customerReviewsHeadline,
		customerReviewsNames = [],
		customerReviewsTitles = [],
		customerReviewsBodys = [],
		customerIcons = [],
		customerReviewsDates = [],
		customerReviewsLogoIcon,
	} = contentfulData;

	const [mobileView, setMobileView] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);
	const scrollContainerRef = useRef(null);

	// Detect screen size and set mobile view accordingly
	useEffect(() => {
		const handleResize = () => {
			const isMobile = window.innerWidth <= 768; // Adjust this as per your mobile breakpoint
			setMobileView(isMobile);
		};

		window.addEventListener('resize', handleResize);
		handleResize(); // Run on initial load
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const nextTestimonial = () => {
		if (currentIndex < customerReviewsNames.length - 1) {
			setCurrentIndex(currentIndex + 1);
		}
	};

	const prevTestimonial = () => {
		if (currentIndex > 0) {
			setCurrentIndex(currentIndex - 1);
		}
	};

	useEffect(() => {
		if (!mobileView || !scrollContainerRef.current) return;

		const handleScrollSync = () => {
			const container = scrollContainerRef.current;
			const scrollLeft = container.scrollLeft;
			const itemWidth = container.offsetWidth;

			// Calculate index by rounding scroll position divided by item width
			let newIndex = Math.round(scrollLeft / itemWidth);

			// If near the end, force the last index
			if (scrollLeft + container.offsetWidth >= container.scrollWidth - 1) {
				newIndex = customerReviewsNames.length - 1;
			}

			setCurrentIndex(newIndex);
		};

		const container = scrollContainerRef.current;
		container.addEventListener('scroll', handleScrollSync);

		return () => {
			container.removeEventListener('scroll', handleScrollSync);
		};
	}, [mobileView, customerReviewsNames.length]);

	const handleScroll = (direction) => {
		if (scrollContainerRef.current) {
			const container = scrollContainerRef.current;
			const itemWidth = container.offsetWidth; // Width of one testimonial

			let newIndex = direction === 'left' ? currentIndex - 1 : currentIndex + 1;

			if (newIndex < 0) newIndex = 0;
			if (newIndex >= customerReviewsNames.length)
				newIndex = customerReviewsNames.length - 1;

			container.scrollTo({
				left: newIndex * itemWidth,
				behavior: 'smooth',
			});

			setCurrentIndex(newIndex); // Update the active dot
		}
	};

	const goToTestimonial = (index) => {
		if (scrollContainerRef.current) {
			const container = scrollContainerRef.current;
			const itemWidth = container.offsetWidth;

			container.scrollTo({
				left: index * itemWidth,
				behavior: 'smooth',
			});

			setCurrentIndex(index); // Update index when clicking a dot
		}
	};

	const FilledStar = () => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
		>
			<g clipPath='url(#clip0_557_7227)'>
				<path
					d='M7.14486 0.86206L5.19196 4.82168L0.822626 5.45869C0.0390758 5.57233 -0.274942 6.53831 0.293281 7.09158L3.4544 10.1719L2.70673 14.5233C2.57216 15.3099 3.40057 15.899 4.0944 15.5312L8.00317 13.4766L11.912 15.5312C12.6058 15.896 13.4342 15.3099 13.2996 14.5233L12.552 10.1719L15.7131 7.09158C16.2813 6.53831 15.9673 5.57233 15.1837 5.45869L10.8144 4.82168L8.86149 0.86206C8.51159 0.156267 7.49775 0.147295 7.14486 0.86206Z'
					fill={
						brandTag === 'fox' || brandTag === 'bon'
							? '#FBBF24'
							: brandTag === 'wsj'
							? '#F7AB89'
							: brandTag === 'law'
							? '#B79178'
							: brandTag === 'osw'
							? '#E06729'
							: '#EE8145'
					}
				/>
			</g>
			<defs>
				<clipPath id='clip0_557_7227'>
					<rect width='16' height='16' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);

	const EmptyStar = () => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
		>
			<g clipPath='url(#clip0_557_7190)'>
				<path
					d='M5.28213 5.44014L5.60719 5.39275L5.7525 5.09814L7.70527 1.13875C7.82563 0.894975 8.17777 0.890573 8.30139 1.13939C8.30144 1.13948 8.30148 1.13958 8.30153 1.13967L10.2539 5.09813L10.3992 5.39275L10.7242 5.44014L15.0936 6.07715L15.094 6.07722C15.3643 6.11641 15.4743 6.45176 15.2771 6.64379L15.2769 6.64396L12.1158 9.72433L11.8803 9.95377L11.936 10.2778L12.6836 14.6287C12.7294 14.8964 12.4458 15.1058 12.2028 14.978L12.2027 14.978L8.29397 12.9234L8.00317 12.7705L7.71238 12.9234L3.8036 14.978L3.80164 14.979C3.56304 15.1055 3.27633 14.9002 3.32278 14.6287L4.07037 10.2778L4.12604 9.95377L3.89058 9.72433L0.729469 6.64396L0.729291 6.64379C0.532079 6.45176 0.642099 6.11641 0.912336 6.07722L0.912792 6.07715L5.28213 5.44014Z'
					stroke={
						brandTag === 'fox' || brandTag === 'bon'
							? '#FBBF24'
							: brandTag === 'wsj'
							? '#F7AB89'
							: brandTag === 'law'
							? '#B79178'
							: brandTag === 'osw'
							? '#E06729'
							: '#EE8145'
					}
					strokeWidth='1.25'
				/>
			</g>
			<defs>
				<clipPath id='clip0_557_7190'>
					<rect width='16' height='16' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);

	// Ratings are no longer sourced from Contentful; always show 5 stars.
	const renderStars = () => {
		const totalStars = 5; // Maximum stars
		const rating = 5;

		// Generate stars based on the rating
		return Array.from({ length: totalStars }, (_, i) =>
			i < rating ? <FilledStar key={i} /> : <EmptyStar key={i} />
		);
	};

	return (
		<TestimonialsSectionContainer>
			{customerReviewsHeadline && (
				<TestimonialsHeading>{customerReviewsHeadline}</TestimonialsHeading>
			)}

			{mobileView ? (
				// Mobile View: Carousel (1 item visible at a time)
				<div>
					<div className='TestimonialsItemScroll' ref={scrollContainerRef}>
						{customerReviewsNames.map((_, currentIndex) => (
							<TestimonialsItem>
								<div className='image-wrap'>
									<img
										width={200}
										height={200}
										src={`https:${customerIcons[currentIndex]?.fields?.file?.url}`}
										alt={customerReviewsNames[currentIndex] || 'Customer Icon'}
									/>
									<h3>{customerReviewsNames[currentIndex]}</h3>
								</div>
								<hr />
								<div className='lp-testimonial-item-info'>
									<div className='star-ratings'>{renderStars()}</div>
									<p className='reviews-Titles'>
										{customerReviewsTitles[currentIndex]}
									</p>
									<p className='reviews-Bodys'>
										{customerReviewsBodys[currentIndex]}
									</p>
									{/* <span>{customerReviewsDates[currentIndex]}</span> */}
								</div>
							</TestimonialsItem>
						))}
					</div>

					<CarouselControls>
						<img
							src='/images/us/common/icons/wsj/angle_left_black.svg'
							onClick={() => handleScroll('left')}
							disabled={currentIndex === 0}
						></img>
						<DotContainer>
							{customerReviewsNames.map((_, index) => (
								<Dot
									key={index}
									active={index === currentIndex}
									onClick={() => goToTestimonial(index)}
								/>
							))}
						</DotContainer>
						<img
							src='/images/us/common/icons/wsj/angle_right_black.svg'
							onClick={() => handleScroll('right')}
							disabled={currentIndex === customerReviewsNames.length - 1}
						></img>
					</CarouselControls>
				</div>
			) : (
				// Desktop View: Grid (multiple items visible)
				<TestimonialsSectionList>
					{customerReviewsNames.map((name, index) => (
						<TestimonialsItem key={index}>
							<div className='image-wrap'>
								<img
									width={200}
									height={200}
									src={`https:${customerIcons[index]?.fields?.file?.url}`}
									alt={name || 'Customer Icon'}
								/>
								<h3>{name}</h3>
							</div>
							<hr />
							<div className='lp-testimonial-item-info'>
								<div className='star-ratings'>{renderStars()}</div>
								<p className='reviews-Titles'>{customerReviewsTitles[index]}</p>
								<p className='reviews-Bodys'>{customerReviewsBodys[index]}</p>
								{/* <span>{customerReviewsDates[index]}</span> */}
							</div>
						</TestimonialsItem>
					))}
				</TestimonialsSectionList>
			)}

			{customerReviewsLogoIcon?.fields?.file?.url && (
				<div className='lp-testimonial-logo'>
					<img
						width={163}
						height={40}
						src={`https:${customerReviewsLogoIcon?.fields?.file?.url}`}
						alt={customerReviewsHeadline}
					/>
				</div>
			)}
		</TestimonialsSectionContainer>
	);
};

export default TestimonialsSection;
